import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Form, Button, Modal, Spinner } from 'react-bootstrap';
import TaskTable from '../TaskTable';
import { useGetTask } from '../../hooks/useTasks';
import { useCheckoutJob, useCompleteJob } from '../../hooks/useJobs';
import { useValveStates } from '../../hooks/useValveStates';
import { SiteContext } from '../Contexts/SiteContext';

function ChangeStateDialogContent({ job, updateJob, closeDialog }) {

    ChangeStateDialogContent.propTypes = {
        job: PropTypes.object,
        updateJob: PropTypes.func,
        closeDialog: PropTypes.func
    }

    const { selectedSite } = useContext(SiteContext);
    const { valveStates } = useValveStates();
    const { completeJob, loading: loadingCompletingJob } = useCompleteJob();
    const { undoCheckoutJob } = useCheckoutJob();
    const { task, loading, error } = useGetTask(selectedSite, job.taskName);
    const [formValidated, setFormValidated] = useState(false);


    const handleSubmit = (event) => {

        event.preventDefault();
        event.stopPropagation();

        setFormValidated(true);

        const form = event.currentTarget;

        if (form.checkValidity() === true) {
            job.valveState = event.target.newValveState.value;
            completeJobAndClose();
        }
    };

    const completeJobAndClose = async () => {

        job = await completeJob(job)

        updateJob(job);

        while (loadingCompletingJob) {

        }

        closeDialog();
    }

    const undoCheckoutJobAndClose = async () => {

        job = await undoCheckoutJob(job)

        updateJob(job);
        closeDialog();
    }

    // wait for task or job completion to load
    if (loading || loadingCompletingJob) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner animation="border" />
            </div>
        );
    }

    let modalBody = (
        <>
            <div className="my-3">
                <p>Required Action: <b>{job.action}</b></p>
                <div className="mb-4">
                    <TaskTable task={task} />
                </div>
            </div>
            <Row>
                <Col>
                    Current State: <b>{job.action === "NoActionRequired" ? "Not known" : job.action === "Close" ? "Open" : "Closed"}</b>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Select name="newValveState" required>
                            <option key="0" value="">Set state...</option>
                            {
                                valveStates && valveStates.map((s, i) => {
                                    return <option key={i + 1} value={s.name}>{s.name}</option>
                                })
                            }
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Set the state to complete the job
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>
        </>
    )

    return (
        <>
            <Form noValidate validated={formValidated} onSubmit={handleSubmit}>
                <Modal.Body>
                    {modalBody}
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button variant="warning" style={{ color: 'white' }} onClick={undoCheckoutJobAndClose}>Undo Checkout</Button>
                    <Button variant="primary" type="submit">Finish</Button>
                </Modal.Footer>
            </Form>
        </>
    );
}

export default ChangeStateDialogContent;